<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'Header'
});
</script>
<template>
  <ka-container
    code="header"
    :data="page.$info.header">
    <!-- Header -->
    <kapix-teleport>
      <ka-container code="container-1">
        <!-- Haut de Page 3 -->
        <ka-container
          code="haut-de-page-3"
          inner>
          <!-- Partie A -->
          <ka-container code="partie-a">
            <ka-image
              code="logo-de-lentreprise"
              :options="{
                animationIn: `fadeIn`,
                href: { path: `/` },
                ariaLabel: `home`,
                lazyOptions: {
                  throttle: 200,
                  once: true,
                  intersection: { threshold: 0.1 }
                },
                click: page.logoDeLentrepriseClick,
                alt: `Logo de l'entreprise`
              }"
              value="https://ucarecdn.com/f1c410a0-cc37-4bfd-b333-509dcc21b41f/" />
            <ka-separator
              code="separator"
              :xs="{ hidden: null }" />
            <HeaderOnglet
              instance-class="header-onglet--m2"
              :options="{ click: page.headerOngletClick }"
              :xs="{ hidden: null }"
              titre-onglet="Entreprise" />
            <HeaderOnglet
              instance-class="element-1--m2"
              :options="{ click: page.element1Click }"
              :xs="{ hidden: null }"
              titre-onglet="Expert" />
            <HeaderOnglet
              instance-class="element-2--m2"
              :options="{ click: page.element2Click }"
              :xs="{ hidden: null }"
              titre-onglet="Formations" />
            <ka-text
              code="onglet-a-propos"
              :options="{
                href: { name: `Infos` },
                click: page.ongletAProposClick,
                textNoWrap: true
              }"
              :xs="{ hidden: null }">
              <span v-html="t('header.container1.hautDePage3.partieA.ongletAPropos.value', `À propos`)" />
            </ka-text>
          </ka-container>
          <!-- Partie B -->
          <ka-container
            code="partie-b"
            :xs="{ hidden: true }">
            <ka-button
              code="contact"
              :options="{
                ripple: true,
                href: { name: `Contact` },
                click: page.contactClick
              }">
              <span v-html="t('header.container1.hautDePage3.partieB.contact.value', `Contact`)" />
            </ka-button>
            <!-- Container-btn-contact -->
            <ka-container code="container-btn-contact">
              <HeaderBtnSonProfilOuConnexion instance-class="header-btn-son-profil-ou-connexion--m2" />
            </ka-container>
          </ka-container>
          <!-- Menu Burger -->
          <ka-container
            code="menu-burger"
            :options="{ hidden: true }"
            :xs="{
              click: page.menuBurgerClickOnXs,
              hidden: false
            }"
            :xs-selected="{ click: page.menuBurgerClickOnXsWhenSelected }">
            <ka-icon
              code="icone"
              :options="{
                hidden: true,
                $inheritState: { selected: true }
              }"
              :xs="{ hidden: false }"
              value="i-fa-solid:icons"
              xs-value="i-fa-solid:align-justify" />
          </ka-container>
        </ka-container>
        <!-- Bande temporaire -->
        <ka-container
          code="bande-temporaire"
          :options="{ style: { hidden: false } }">
          <ka-icon
            code="icon"
            :options="{
              click: page.iconClick,
              $state: { selected: $isEqual(page.$elements['bande-temporaire']?.style.hidden, page.$constants.bandeTemporaireHidden) }
            }"
            value="i-fa-solid:times" />
          <ka-text
            code="matchers-leve-2-m"
            :options="{
              href: { name: `Histoire` },
              click: page.MatchersLeve2MClick
            }">
            <span v-html="t('header.container1.bandeTemporaire.MatchersLeve2M.value', `🔥 Matchers lève 2M€ pour démocratiser la formation dans les TPE 🔥  `)" />
            <template #xs>
              <span v-html="t('header.container1.bandeTemporaire.MatchersLeve2M.xs.value', `🔥 Matchers lève 2M€ 🔥 `)" />
            </template>
          </ka-text>
        </ka-container>
      </ka-container>
    </kapix-teleport>
    <ka-page-router code="page-router" />
  </ka-container>
</template>

<script setup lang="ts">
import { syncPageStore } from 'kapix-components-vue3'
import { headerLayout } from './Header/store'
import HeaderBtnSonProfilOuConnexion from '~/components/HeaderBtnSonProfilOuConnexion/index.vue'
import HeaderOnglet from '~/components/HeaderOnglet/index.vue'
import './Header/style.scss'
import './Header/style.custom.scss'


provide('$scoped', '--m2')
const page = syncPageStore(headerLayout())
</script>
